"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPane = void 0;
const React = __importStar(require("react"));
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const styled_components_1 = __importDefault(require("styled-components"));
const ZPaneTitle = styled_components_1.default.div `
   font-size: 16px;
   font-weight: 600;
   color: ${props => props.theme["pane-header-color"]};
   line-height: 20px;
   text-transform: uppercase;
   padding: 5px 10px;
   width: 100%;
   height: 20px;
   display: block;
`;
function ZPaneBodyComponent(props) {
    return React.createElement("div", { className: props.className }, props.children);
}
const ZPaneBody = styled_components_1.default(ZPaneBodyComponent) `
   margin: 0 10px;
   background-color: ${props => props.theme["pane-body-background-color"]};
   padding: 15px;
   width: calc(100% - 50px);
   display: block;
`;
function ZPaneButtonsComponent(props) {
    return React.createElement("div", { className: props.className }, props.children);
}
const ZPaneButtons = styled_components_1.default(ZPaneButtonsComponent) `
   margin: 5px 10px 0 5px;
   & .k-button {
      width: 125px;
      margin-bottom: 4px;
   }
   width: 146px;
   display: inline-block;
   vertical-align: top;
`;
const PaneLeft = styled_components_1.default.div `
   display: inline-block;
   margin: 10px 10px 0 10px;
   padding-bottom: 10px;
   background: ${props => props.theme["pane-border-color"]};
   position: relative;
   box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
   transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
   width: ${props => props.buttons !== null ? "calc(100% - 146px - 15px - 20px)" : "100%"};
`;
function ZPaneComponent(props) {
    const { paneTitle } = useLocalizedProps_1.useLocalizedProps({
        ...props,
        propsToLocalize: ["paneTitle"]
    });
    return (React.createElement("div", null,
        React.createElement(PaneLeft, { className: props.className, buttons: props.buttons },
            React.createElement(ZPaneTitle, null, paneTitle),
            React.createElement(ZPaneBody, null, props.children)),
        props.buttons !== null ? (React.createElement(ZPaneButtons, null, props.buttons)) : null));
}
exports.ZPane = ZPaneComponent;
//# sourceMappingURL=ZPane.js.map